import {
  DocumentPage,
  DocumentPageCreate,
  DocumentPageReorderItem,
  DocumentPageUpdate,
} from '@/app/platform/functions/documents/document-page.types.ts';
import { apiService } from '@/app/platform/core/api/api.service.ts';
import { DocumentRevision } from '@/app/platform/functions/documents/editor/documentRevisionTypes.ts';

class DocumentPageService {
  private base(projectId: string, projectDocumentId: string) {
    return `/platform/functions/documents/projects/${projectId}/documents/${projectDocumentId}/pages`;
  }

  list(projectId: string, projectDocumentId: string): Promise<DocumentPage[]> {
    return apiService.get<DocumentPage[]>(
      this.base(projectId, projectDocumentId),
    );
  }

  create(
    projectId: string,
    projectDocumentId: string,
    data: DocumentPageCreate,
  ): Promise<DocumentPage> {
    return apiService.post<DocumentPage>(
      this.base(projectId, projectDocumentId),
      data,
    );
  }

  get(
    projectId: string,
    projectDocumentId: string,
    pageId: string,
  ): Promise<DocumentPage> {
    return apiService.get<DocumentPage>(
      `${this.base(projectId, projectDocumentId)}/${pageId}`,
    );
  }

  update(
    projectId: string,
    projectDocumentId: string,
    pageId: string,
    data: DocumentPageUpdate,
  ): Promise<DocumentPage> {
    return apiService.put<DocumentPage>(
      `${this.base(projectId, projectDocumentId)}/${pageId}`,
      data,
    );
  }

  listDocumentRevisions(
    projectId: string,
    projectDocumentId: string,
    pageId: string,
  ): Promise<DocumentRevision[]> {
    return apiService.get<DocumentRevision[]>(
      `${this.base(projectId, projectDocumentId)}/${pageId}/revisions`,
    );
  }

  archive(
    projectId: string,
    projectDocumentId: string,
    pageId: string,
  ): Promise<void> {
    return apiService.patch<void>(
      `${this.base(projectId, projectDocumentId)}/${pageId}/archive`,
    );
  }

  reorder(
    projectId: string,
    projectDocumentId: string,
    items: DocumentPageReorderItem[],
  ): Promise<void> {
    return apiService.patch<void>(
      `${this.base(projectId, projectDocumentId)}/reorder`,
      { items },
    );
  }
}

export const documentPageService = new DocumentPageService();
